import { customerSurveyConstants } from "../../../constants";

/**
 * Apply survey theme CSS custom properties on the document root.
 */
export const applySurveyThemeStyles = ({
  mainThemeColor,
  fontColor,
  fontStyle,
  progressBarColor,
  defaultMainThemeColor = customerSurveyConstants.DEFAULT_MAIN_THEME_COLOR,
}) => {
  const {
    DEFAULT_FONT_COLOR,
    DEFAULT_FONT_FAMILY,
    DEFAULT_PROGRESS_BAR_COLOR,
    CSS_MAIN_THEME,
    CSS_FONT_COL,
    CSS_FONT_FAMILY,
    CSS_BAR_COL,
  } = customerSurveyConstants;

  document.documentElement.style.setProperty(
    CSS_MAIN_THEME,
    mainThemeColor || defaultMainThemeColor,
  );
  document.documentElement.style.setProperty(
    CSS_FONT_COL,
    fontColor || DEFAULT_FONT_COLOR,
  );
  document.documentElement.style.setProperty(
    CSS_FONT_FAMILY,
    fontStyle || DEFAULT_FONT_FAMILY,
  );
  document.documentElement.style.setProperty(
    CSS_BAR_COL,
    progressBarColor || DEFAULT_PROGRESS_BAR_COLOR,
  );
};
